import type { OpcoesDeToast, Toast } from './types'

type Ouvinte = () => void

const DURACAO_PADRAO = 5000
const LIMITE_DE_TOASTS = 4

let toasts: Toast[] = []
let proximoId = 0

const ouvintes = new Set<Ouvinte>()

function notificar(): void {
  for (const ouvinte of ouvintes) {
    ouvinte()
  }
}

export function inscrever(ouvinte: Ouvinte): () => void {
  ouvintes.add(ouvinte)

  return () => {
    ouvintes.delete(ouvinte)
  }
}

export function obterToasts(): Toast[] {
  return toasts
}

export function adicionarToast(
  titulo: string,
  opcoes: OpcoesDeToast = {}
): string {
  proximoId += 1

  const toast: Toast = {
    tipo: 'info',
    duracao: DURACAO_PADRAO,
    ...opcoes,
    id: `toast-${proximoId}`,
    titulo,
  }

  toasts = [...toasts, toast].slice(-LIMITE_DE_TOASTS)
  notificar()

  return toast.id
}

export function removerToast(id: string): void {
  const restantes = toasts.filter(toast => toast.id !== id)

  if (restantes.length === toasts.length) return

  toasts = restantes
  notificar()
}

export function limparToasts(): void {
  if (toasts.length === 0) return

  toasts = []
  notificar()
}
